var RedemptionEventOptions;
(function (RedemptionEventOptions) {
    RedemptionEventOptions["UsersDateOfBirth"] = "USERS_DATE_OF_BIRTH";
})(RedemptionEventOptions || (RedemptionEventOptions = {}));
export var RedemptionEventDeal;
(function (RedemptionEventDeal) {
    RedemptionEventDeal["BirthdayBox"] = "80b51138-5ce0-4c97-981e-541729e29022";
})(RedemptionEventDeal || (RedemptionEventDeal = {}));
export default RedemptionEventOptions;
